import React, {useContext, useEffect, useRef, useState} from "react";
import FilterContext from "../Context/FilterContext";

const Checkbox = props => {
    const { attribute, item, refine, canRefine, checked } = props
    const { setLoading, setSearchParams } = useContext(FilterContext)

    const [mounted, setMounted] = useState(false)

    const input = useRef()

    const onChange = e => {
        if (setLoading) setLoading(true)
        refine(item.value)

        setSearchParams(state => {
            if (!state.has(attribute) && e.target.checked) {
                state.append(attribute, item.value)
            } else {
                if (!state.getAll(attribute).includes(item.value) && e.target.checked) {
                    state.append(attribute, item.value)
                } else {
                    const params = state.getAll(attribute).filter(param => param !== item.value);

                    state.delete(attribute);

                    for (const item of params) state.append(attribute, item);
                }
            }
            return state
        }, { replace: true })
    }

    useEffect(() => {
        input.current?.addEventListener('change', onChange)

        if (checked) {
            input.current?.setAttribute('checked', 'checked')
            if (setLoading) setLoading(true)
            refine(item.value)
        } else {
            input.current?.removeAttribute('checked')
        }

        setMounted(true)

        return () => input.current?.removeEventListener('change', onChange)
    }, [])

    useEffect(() => {
        if (!mounted) return;

        checked ?
            input.current?.setAttribute('checked', 'checked') :
            input.current?.removeAttribute('checked')
    }, [checked])

    return (
        <div key={item.value} className={'flex items-center justify-between gap-2'}>
            <div className={'flex items-center'}>
                <input ref={input} id={item.value} type="checkbox" disabled={item.count === 0 || !canRefine} className={'p-3 rounded-lg block border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-200 focus:border-indigo-800 focus:ring focus:ring-indigo-800 focus:ring-opacity-25 checked:bg-indigo-800 checked:hover:bg-indigo-700'}/>
                <label className={'pl-4 text-sm text-gray-600'} htmlFor={item.value}>{item.label}</label>
            </div>
            <span className={'inline-flex flex-shrink-0 px-2 py-1 rounded-md bg-blue-50 text-blue-500 text-xs shadow'}>{item.count}</span>
        </div>
    )
}

export default Checkbox